module.exports = __webpack_public_path__ + "img/multiple_claims.eeafdc6.svg";